export default defineNuxtPlugin(async () => {
  const { initializeAuth, initFavoriteIds, initLikeIds } = useUser()

  await initializeAuth()
  await initFavoriteIds()
  await initLikeIds()
})
